module.exports = __webpack_public_path__ + "static/img/061_TO8_1617_og.03306a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/061_TO8_1617_og.jpg
// module id = V84M
// module chunks = 0